export default "__VITE_ASSET__cbe833a7__"